module.exports = __webpack_public_path__ + "media/customizations/harvestgreen/back-9c9f70581758e9e671bc6d6ba6a98d94.jpg";